import React from "react";
import { motion, useReducedMotion } from "framer-motion";
type TitleUnderlineProps = {
  children: React.ReactNode;
  /** Trailing punctuation (e.g. ".") kept on the same line as the word, outside the underline. */
  suffix?: string;
};

/**
 * A slanted, tapered pen stroke under a key word in a heading – thin at the start,
 * swelling in the middle and lifting off with a small flick at the end, like ink from a nib.
 */
export function TitleUnderline({
  children,
  suffix
}: TitleUnderlineProps) {
  const reduce = useReducedMotion();
  const underlined = <span className="relative inline-block whitespace-nowrap" data-id="element-273" data-mp="1mfngz10hzy6k">
      {children}
      <motion.span aria-hidden="true" className="pointer-events-none absolute -bottom-[0.34em] left-[-4%] block h-[0.48em] w-[108%] text-blush" initial={reduce ? false : {
      clipPath: "inset(0% 100% 0% 0%)"
    }} whileInView={{
      clipPath: "inset(0% 0% 0% 0%)"
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      delay: 0.15,
      ease: [0.4, 0, 0.2, 1]
    }} data-id="element-274" data-mp="20caqe39n0gtd">
        <svg viewBox="0 0 200 40" preserveAspectRatio="none" className="block h-full w-full" data-id="element-275" data-mp="18s8bcztd3xak">
          <path d="M4 19 C 18 14, 42 11, 72 15 C 100 19, 118 25, 146 25 C 172 25, 189 18, 199 10 C 188 20, 172 31, 146 31 C 116 31, 98 25, 72 20 C 44 15, 20 16, 4 19 Z" fill="currentColor" data-id="element-276" data-mp="1drbgek9ce3ij" />
        </svg>
      </motion.span>
    </span>;
  if (!suffix) return underlined;
  return <span className="whitespace-nowrap" data-id="element-277" data-mp="1wjx7ysd7v7xb">
      {underlined}
      {suffix}
    </span>;
}